<div id="container">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="tour-form">
    <h2>{{ title }}</h2>

    <ng-container formGroupName="title">
      <mat-form-field *ngFor="let lang of availableLangs" appearance="fill">
        <mat-label i18n>Title {{ lang }}</mat-label>
        <input matInput [formControlName]="lang" required>
        <button matIconSuffix mat-icon-button type="button" (click)="translateTitle(lang)"
                *ngIf="(languageService.currentLang$ | async) === lang">
          <mat-icon>g_translate</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>

    <ng-container formGroupName="description">
      <mat-form-field *ngFor="let lang of availableLangs" appearance="fill">
        <mat-label><span i18n>Description</span> {{ lang }}</mat-label>
        <textarea cdkTextareaAutosize matInput [formControlName]="lang"></textarea>
        <button matIconSuffix mat-icon-button type="button" (click)="translateDescription(lang)"
                *ngIf="(languageService.currentLang$ | async) === lang">
          <mat-icon>g_translate</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>

    <mat-form-field appearance="fill">
      <mat-label i18n>Step</mat-label>
      <input matInput formControlName="step" type="number" min="0" step="1" required>
      @if (form.controls['step'].hasError('stepExists')) {
        <mat-error>Step already exists</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label i18n>Audio folder</mat-label>
      <input readonly matInput (blur)="audioHint = false" (focus)="audioHint = true"
             formControlName="audioStorageFolder">
      @if (audioHint) {
        <mat-hint i18n>Select a folder from the list</mat-hint>
      }
    </mat-form-field>

    <br>

    <audio #audioElement controls>

    </audio>

    <br>

    <mat-form-field>
      <ngx-mat-file-input
        (change)="showCropper = true; fileChangeEvent($event)"
        i18n-valuePlaceholder
        valuePlaceholder="Select an image"></ngx-mat-file-input>
      <mat-icon matSuffix>folder</mat-icon>
    </mat-form-field>

    <div [hidden]="!showCropper">
      <h3 i18n>Cropper</h3>
      <image-cropper
        #cropperComponent
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="false"
        [imageURL]="tour?.rawImageUrl"
        format="jpeg"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady($event)"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>

      <h3 i18n>Result </h3>

      <img [src]="croppedImage" class="resultImg" />

    </div>

    <br>

    <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid" i18n>Submit</button>

  </form>

  <div id="trees">
    <div class="tree">
      <h2 i18n>Unused</h2>

      <ng-container *ngTemplateOutlet="matTree; context: { $implicit: dataSourceUnused }"></ng-container>
    </div>
    <div class="tree">
      <h2 i18n>Used</h2>

      <ng-container *ngTemplateOutlet="matTree; context: { $implicit: dataSourceUsed }"></ng-container>
    </div>
  </div>
</div>

<ng-template #matTree let-datasource>
  <mat-tree [dataSource]="datasource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-icon-button type="button" (click)="playSound(node)">
        <mat-icon>play_circle</mat-icon>
      </button>
      {{ node.name }}
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle type="button"
              [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <span class="node-name">{{ node.name }}</span>
      <span class="mat-caption" matTooltip="The step" i18n-matTooltip *ngIf="node?.step">({{ node.step }})</span>
      <button mat-icon-button type="button"
              [color]="form.controls['audioStorageFolder'].value === node.name ? 'accent' : 'primary'"
              (click)="selectFolder(node)">
        <mat-icon>done</mat-icon>
      </button>
    </mat-tree-node>
  </mat-tree>
</ng-template>
